import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export interface IStripeConfig {
  publishableKey: string;
}

/** Not a secret -- lets the frontend bootstrap Stripe.js without hardcoding the publishable key per environment. */
export const getStripeConfig = async (): Promise<IStripeConfig> => {
  const response = await apiService<IStripeConfig>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_STRIPE_CONFIG,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load Stripe config');
};
